/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TenantSettingKey } from './tenantSettingKey';


export interface TenantSettingApiModel { 
    key: TenantSettingKey;
    value: string;
}
export namespace TenantSettingApiModel {
}


